import { strVal } from '../../../../../modules/Utils'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import CustomSpin from '../../../../../elements/CustomSpin'
import FormSectionTitle from '../../../../../elements/FormSectionTitle'
import React, { Component } from 'react'
import { Col, Form, Input, message, Row, Select } from 'antd'
import CountrySelect from '../../../../../elements/Select/Country'
import { get, isEmpty } from 'lodash'
import InfoText from '../../../../../elements/InfoText'
import { compose } from 'recompose'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import Members from '../../../../../api/Members'
import withData from '../../../../../elements/Select/withData'

class Communication extends Component {
  state = {
    ClientRepSelect: Select,
    fetching: false,
    companyReps: [],
    clientReps: [],
    CompanyRepSelect: Select,
  }
  membersApi = new Members()

  componentDidMount() {
    this.fetchClientReps()
    this.fetchCompanyReps()
  }

  onChangeBillingRep = (owner) => {
    const rep = this.state.clientReps.find((r) => r.owner === owner) || {}
    this.props.form.setFieldsValue({
      'payableRep.phone.label': rep.phone || rep.mobile,
      'payableRep.email.label': rep.email,
      'payableRep.address.label': rep.address,
    })
  }
  onChangeClientRep = (owner) => {
    const rep = this.state.clientReps.find((r) => r.owner === owner) || {}
    this.props.form.setFieldsValue({
      'clientRep.phone.label': rep.phone || rep.mobile,
      'clientRep.email.label': rep.email,
      'clientRep.address.label': rep.address,
    })
  }
  onChangeCompanyRep = (owner) => {
    const rep = this.state.companyReps.find((r) => r.owner === owner) || {}
    this.props.form.setFieldsValue({
      'companyRep.phone.label': rep.phone || rep.mobile,
      'companyRep.email.label': rep.email,
    })
  }
  fetchClientReps = async () => {
    const client = get(this.props, 'client.owner')
    const member = get(this.props, 'member')
    if (!isEmpty(client)) {
      try {
        this.setState({
          fetching: true,
        })
        let data = []
        if (member.kind !== 'individual') {
          const response = await this.membersApi.representatives.list(client.replace('members/', ''))
          data = await response.json()
        } else {
          const mappedMember = {
            repID: member._key,
            owner: member._id,
            name: member.fn,
            email: get(member, 'email.label'),
            phone: get(member, 'phone.label'),
            mobile: get(member, 'mobile.label'),
          }
          data = [mappedMember]
        }

        this.setState({
          clientReps: data,
          // ClientRepSelect,
          fetching: false,
        })
      } catch (e) {
        this.setState({
          fetching: false,
        })
        message.error(e.errorMessage)
      }
    }
  }
  fetchCompanyReps = async () => {
    const company = get(this.props, 'contract.company._id')
    if (!isEmpty(company)) {
      try {
        this.setState({
          fetching: true,
        })
        const response = await this.membersApi.representatives.list(company.replace('members/', ''))
        const data = await response.json()
        const CompanyRepSelect = compose(
          withData({
            data,
          }),
          withSort
        )(CustomSelect)
        this.setState({
          companyReps: data,
          CompanyRepSelect,
          fetching: false,
        })
      } catch (e) {
        this.setState({
          fetching: false,
        })
        message.error(e.errorMessage)
      }
    }
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { contract, type } = this.props
    const { clientReps, fetching, companyReps } = this.state

    const ClientRepSelect = compose(
      withData({
        data: clientReps,
        fetch: this.fetchClientReps,
        fetching: fetching,
      }),
      withSort
    )(CustomSelect)

    const CompanyRepSelect = compose(
      withData({
        data: companyReps,
        fetch: this.fetchCompanyReps,
        fetching: fetching,
      }),
      withSort
    )(CustomSelect)

    //  const { SelectData: CompanyRepEmailSelect } = useFetchSelect({
    //     url: `contacts/email/${(companyRep || '').replace('members/', '')}`,
    //     dependencyArray: [companyRep],
    //     dontFetch: isEmpty(companyRep),
    //   })

    const client = getFieldValue('clientRep._id') || strVal(contract, 'clientRep._id', '')
    const ClientEmailSelect = compose(
      withUrlFetch({
        name: 'clientRep',
        url: `contacts/email/${client.replace('members/', '')}`,
        dontFetch: isEmpty(client),
      }),
      withSpinning
    )(CustomSelect)

    const company = getFieldValue('companyRep._id') || strVal(contract, 'companyRep._id', '')
    const CompanyEmailSelect = compose(
      withUrlFetch({
        name: 'companyRep',
        url: `contacts/email/${company.replace('members/', '')}`,
        dontFetch: isEmpty(company),
      }),
      withSpinning
    )(CustomSelect)

    const payable = getFieldValue('payableRep._id') || strVal(contract, 'payableRep._id', '')
    const PayableEmailSelect = compose(
      withUrlFetch({
        name: 'payableRep',
        url: `contacts/email/${payable.replace('members/', '')}`,
        dontFetch: isEmpty(payable),
      }),
      withSpinning
    )(CustomSelect)

    console.log(444, contract)

    return (
      <Form layout="horizontal">
        <FormSectionTitle title={'CUSTOMER NOTICE ADDRESS'} />
        <Row>
          <Col span={12}>
            <Form.Item label="Country" {...formItemLayout}>
              {getFieldDecorator('client.address.country', {
                initialValue: get(contract, 'client.address.country'),
                rules: [
                  {
                    required: true,
                    message: "Country can't be empty ",
                  },
                ],
              })(<CountrySelect />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Postcode" {...formItemLayout}>
              {getFieldDecorator('client.address.postcode', {
                initialValue: get(contract, 'client.address.postcode'),
              })(<Input placeholder="Postcode" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label="Street" {...formItemLayout}>
              {getFieldDecorator('client.address.street', {
                initialValue: get(contract, 'client.address.street'),
                rules: [
                  {
                    required: true,
                    message: "Street can't be empty ",
                  },
                ],
              })(<Input placeholder="Street" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label="Building" {...formItemLayout}>
              {getFieldDecorator('client.address.address', {
                initialValue: get(contract, 'client.address.address'),
              })(<Input placeholder="Building" />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item label="Town / Suburb" {...formItemLayout}>
              {getFieldDecorator('client.address.city', {
                initialValue: get(contract, 'client.address.city'),
              })(<Input placeholder="Town / Suburb" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="City / State" {...formItemLayout}>
              {getFieldDecorator('client.address.state', {
                initialValue: get(contract, 'client.address.state'),
                rules: [
                  {
                    required: true,
                    message: '"City / State can\'t be empty ',
                  },
                ],
              })(<Input placeholder="City / State" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label="Label" {...formItemLayout}>
              {getFieldDecorator('client.address.label', {
                initialValue: get(contract, 'client.address.label'),
              })(<Input placeholder="Label" />)}
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>CUSTOMER CONTRACT REPRESENTATIVE</h3>
        </Row>
        <Row>
          <CustomSpin spinning={fetching}>
            <Col span={12}>
              <Form.Item label="Representative" {...formItemLayout}>
                {getFieldDecorator('clientRep._id', {
                  initialValue: get(contract, 'clientRep._id'),
                  rules: [
                    {
                      required: true,
                      message: "Representative can't be empty ",
                    },
                  ],
                })(<ClientRepSelect onChange={this.onChangeClientRep} keyAtr={'owner'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
          </CustomSpin>
          <Col span={12}>
            <Form.Item label="Phone" {...formItemLayout}>
              {getFieldDecorator('clientRep.phone.label', {
                initialValue: get(contract, 'clientRep.phone.label'),
                rules: [
                  {
                    required: true,
                    message: "Phone can't be empty ",
                  },
                ],
              })(<Input placeholder="Phone" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Email" {...formItemLayout}>
              {getFieldDecorator('clientRep.email.label', {
                initialValue: get(contract, 'clientRep.email.label'),
                rules: [
                  {
                    required: true,
                    message: "Email can't be empty ",
                  },
                ],
              })(<ClientEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Address" {...formItemLayout}>
              {getFieldDecorator('clientRep.address.label', {
                initialValue: get(contract, 'clientRep.address.label'),
              })(<Input placeholder="Address" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>CUSTOMER BILLING REPRESENTATIVE</h3>
        </Row>
        <Row>
          <CustomSpin spinning={fetching}>
            <Col span={12}>
              <Form.Item label="Billing Representative" {...formItemLayout}>
                {getFieldDecorator('payableRep._id', {
                  initialValue: get(contract, 'payableRep._id'),
                  rules: [
                    {
                      required: true,
                      message: " Billing Representative can't be empty ",
                    },
                  ],
                })(<ClientRepSelect onChange={this.onChangeBillingRep} keyAtr={'owner'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
          </CustomSpin>
          <Col span={12}>
            <Form.Item label="Phone" {...formItemLayout}>
              {getFieldDecorator('payableRep.phone.label', {
                initialValue: get(contract, 'payableRep.phone.label'),
                rules: [
                  {
                    required: true,
                    message: "Phone can't be empty ",
                  },
                ],
              })(<Input placeholder="Phone" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Email" {...formItemLayout}>
              {getFieldDecorator('payableRep.email.label', {
                initialValue: get(contract, 'payableRep.email.label'),
                rules: [
                  {
                    required: true,
                    message: "Email can't be empty ",
                  },
                ],
              })(<PayableEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Address" {...formItemLayout}>
              {getFieldDecorator('payableRep.address.label', {
                initialValue: get(contract, 'payableRep.address.label'),
              })(<Input placeholder="Address" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>COMPANY CONTRACT REPRESENTATIVE</h3>
        </Row>
        <Row>
          <CustomSpin spinning={fetching}>
            <Col span={12}>
              <Form.Item label="Representative" {...formItemLayout}>
                {getFieldDecorator('companyRep._id', {
                  initialValue: get(contract, 'companyRep._id'),
                  rules: [{ required: true, message: 'Please Select a Representative!' }],
                })(<CompanyRepSelect onChange={this.onChangeCompanyRep} keyAtr={'owner'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
          </CustomSpin>
          <Col span={12}>
            <Form.Item label="Phone" {...formItemLayout}>
              {getFieldDecorator('companyRep.phone.label', {
                initialValue: get(contract, 'companyRep.phone.label'),
                rules: [
                  {
                    required: true,
                    message: "Phone can't be empty ",
                  },
                ],
              })(<Input placeholder="Phone" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Email" {...formItemLayout}>
              {getFieldDecorator('companyRep.email.label', {
                initialValue: get(contract, 'companyRep.email.label'),
                rules: [
                  {
                    required: true,
                    message: "Email can't be empty ",
                  },
                ],
              })(<CompanyEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
            </Form.Item>
          </Col>
        </Row>
        {type !== 'update' && <InfoText text={'Contact details are pre-loaded from client default contacts'} />}
      </Form>
    )
  }
}

export default compose(Form.create())(Communication)
